// modais
import QuickAnswersModal from "../../components/QuickAnswersModal";
import ConfirmationModal from "../../components/ConfirmationModal";

// icones
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SearchIcon from "@material-ui/icons/Search";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

// utilitarios
import { Avatar, Box, Button, FormControl, Grid, InputAdornment, Menu, MenuItem, Select, TextField, CheckBox, Chip, Fade, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography, Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useReducer, useState } from "react";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import socket from "../../hooks/useSocket";
import MultiSelect from "../../components/InputStyled/multiselect";
import { toast } from "react-toastify";

const initialState = [];

const reducer = (state = initialState, action) => {
  if (action.type === "LOAD_QUICK_ANSWERS") {
    const quickAnswers = action.payload;
    return !quickAnswers ? [] : quickAnswers;
  }

  if (action.type === "UPDATE_QUICK_ANSWERS") {
    let { quickAnswer } = action.payload;
    if (!quickAnswer) quickAnswer = action.payload;
    if (!quickAnswer) return;

    const quickAnswerIndex = state.findIndex((q) => q.id === quickAnswer.id);

    if (quickAnswerIndex !== -1) {
      state[quickAnswerIndex] = quickAnswer;
      return [...state];
    } else {
      return [quickAnswer, ...state];
    }
  }

  if (action.type === "DELETE_QUICK_ANSWERS") {
    const quickAnswerId = action.payload;

    const quickAnswerIndex = state.findIndex((u) => u.id === quickAnswerId);
    if (quickAnswerIndex !== -1) {
      state.splice(quickAnswerIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy)
    : (a, b) => -descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy);
}

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "shortcut",
    disablePadding: true,
    label: i18n.t("quickAnswers.table.shortcut"),
    sortable: false,
  },
  {
    id: "quickAnswers",
    disablePadding: false,
    label: i18n.t("quickAnswers.table.message"),
    sortable: false,
  },
  {
    id: "creator",
    disablePadding: false,
    label: i18n.t("quickAnswers.table.creator"),
    sortable: true,
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: i18n.t("quickAnswers.table.actions"),
    sortable: false,
  },
];

const EnhancedTableHead = (props) => {
  const {
    classes,
    order,
    orderBy,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <>
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => {
            const isSortable = headCell.sortable !== false; // Verifica se a coluna é ordenável
            return (
              <TableCell
                key={headCell.id}
                align="left"
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={
                  isSortable && orderBy === headCell.id ? order : false
                }
              >
                {isSortable ? (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                    ) : null}
                  </TableSortLabel>
                ) : (
                  headCell.label // Sem TableSortLabel para colunas não ordenáveis
                )}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    </>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  modalStyle: {
    padding: "20px",
    maxheight: "95vh!important",
    minWidth: "670px",
    background: "#ffffff",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
    "@media (max-width: 740px)": {
      padding: "0px !important",
      marginTop: "65px",
    }
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchInput: {
    float: "right",
    marginRight: "10px",
    "&>div": {
      backgroundColor: "rgba(0,0,0,0)",
      height: "38px",
      lineHeight: "38px",
      "&>div": {
        marginTop: "0!important"
      }
    },
    "& input": {
      height: "38px",
      lineHeight: "38px",
      padding: "0"
    }
  },
  addButton: {
    float: "right",
    height: "38px"
  }
}));

export default function QuickAnswers() {
  const { user } = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("shortcut");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchParam, setSearchParam] = useState("");
  const [enterSearchParam, setEnterSearchParam] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedQuickAnswers, setSelectedQuickAnswers] = useState(null);
  const [quickAnswersModalOpen, setQuickAnswersModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deletingQuickAnswers, setDeletingQuickAnswers] = useState(null);
  const [quickAnswers, dispatch] = useReducer(reducer, []);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const totalPages = Math.ceil(total / rowsPerPage);

  const FilteredQuickAnswer = (qck) => {

    if (qck.adminId != user.adminId) {
      return false;
    }

    if (!qck) {
      return false;
    }

    // se estiver pesquisando não atualizar
    if (enterSearchParam && enterSearchParam != "" && enterSearchParam != "undefined") {
      return false;
    }

    // verificar status
    if (Array.isArray(selectedUserIds) && selectedUserIds.length > 0 && selectedUserIds.includes(qck.createdBy) == false) { return false }
    return true;
  }

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    // criar validação se possuí licenças de usuários
    (async () => {
      try {
        const { data: userList } = await api.get(`/usersList`, {
          signal: abortController.signal,
        });
        if (!isMounted) return;

        if (Array.isArray(userList)) {
          setUsers(userList);
          return;
        }

      } catch (err) {
        if (!isMounted || err.name == 'AbortError') return;
        console.error({ err });
        toastError(err);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const quickAnswerEventName = `quickAnswer-${user.adminId}`;
    const quickAnswerEventFunction = async (data) => {
      if (data.action === "update" || data.action === "create") {
        if (FilteredQuickAnswer(data.quickAnswer) == true) {
          dispatch({ type: "UPDATE_QUICK_ANSWERS", payload: data.quickAnswer });
        } else {
          // se não passou no filtro e existe na lista atual, remover
          const qIdx = quickAnswers.findIndex(u => u.id == data?.quickAnswer?.id);
          if (qIdx != -1) {
            dispatch({ type: "DELETE_QUICK_ANSWERS", payload: +data.quickAnswer.id });
          }
        }
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_QUICK_ANSWERS", payload: +data.quickAnswerId });
      }
    };
    socket.on(quickAnswerEventName, quickAnswerEventFunction);

    return () => {
      socket.off(quickAnswerEventName, quickAnswerEventFunction);
    };
  }, [, user, selectedUserIds, enterSearchParam]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {

    let isMounted = true;
    const abortController = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/quickAnswers/", {
          params: {
            page,
            rowsPerPage,
            order,
            orderBy,
            searchParam,
            selectedUserIds
          },
          signal: abortController.signal,
        });
        if (!isMounted) {
          setLoading(false);
          return;
        }
        dispatch({ type: "LOAD_QUICK_ANSWERS", payload: data.quickAnswers }); // Verifique se o payload é o esperado
        setTotal(data.total);
      } catch (err) {
        if (!isMounted || err.name == 'AbortError') {
          setLoading(false);
          return;
        }
        console.error(err);
        toastError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [ , page, rowsPerPage, order, orderBy, enterSearchParam, selectedUserIds]);

  const handleChangePage = (event, newPage) => {
    // Verifica se a nova página está dentro dos limites
    newPage += 1;
    if (newPage <= 0) {
      setPage(1);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const searchByText = () => {
    if (!searchParam || searchParam == "undefined") return;
    setEnterSearchParam(!enterSearchParam);
  }

  const handleSearch = (event) => {
    if (event.key == "Enter") {
      searchByText();
      return;
    }

    let str = String(event.target.value).trim().toLowerCase();
    if (str == "undefined") str = "";

    setSearchParam(str);
    if (str == "" || str == null) searchByText();

  };

  const handleOpenModal = () => {
    setSelectedQuickAnswers(null);
    setQuickAnswersModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedQuickAnswers(null);
    setQuickAnswersModalOpen(false);
  };

  const handleEdit = (quickAnswer) => {
    setSelectedQuickAnswers(quickAnswer);
    setSelectedUserIds([]);
    setQuickAnswersModalOpen(true);
  };

  const handleDeleteQuickAnswers = async (quickAnswerId) => {
    try {
      await api.delete(`/quickAnswers/${quickAnswerId}`);
      toast.success(i18n.t("quickAnswers.toasts.deleted"));
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
    setConfirmModalOpen(false);
    setDeletingQuickAnswers(null);
    setPage(1);
  };

  function returnSvg(texto, mediaName = null, mediaUrl = null) {
    let fileName = mediaName || 'Arquivo';

    return <Tooltip
      arrow
      title={
        <Typography gutterBottom color="inherit">
          download
        </Typography>
      }
    >
      <Typography
        style={{ display: "flex", margin: "0px", width: "fit-content", color: "#000" }}
        component="a"
        href={mediaUrl || "#"}
        download={mediaUrl ? true : false}
        target="_blank"
      >
        {texto ? texto + '/ ' : ''}{fileName} <InsertDriveFileIcon />
      </Typography>
    </Tooltip>;
  }

  return (
    <>
      <Box component="div" className={classes.modalStyle} id="boxQuickAnswer">
        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Typography variant="h5" style={{ fontWeight: "600" }}>{i18n.t("quickAnswers.title")}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenModal}
              className={classes.addButton}
            >
              <AddOutlinedIcon />
              {i18n.t("quickAnswers.buttons.add")}
            </Button>
            <TextField
              placeholder={i18n.t("quickAnswers.search")}
              variant="filled"
              type="search"
              value={searchParam}
              background="transparent"
              className={classes.searchInput}
              onKeyDown={handleSearch}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "gray" }} onClick={searchByText} />
                  </InputAdornment>
                ),
              }}
            />
            <MultiSelect
              closeOnSelect={true}
              disabled={false}
              displayText={i18n.t("quickAnswers.filterDefault")}
              title={undefined}
              options={Array.isArray(users) && users.length > 0 ? users.map((u) => { return { key: u.id, value: u.name } }) : []}
              key={`selectQuickAnswerUserFilter`}
              onSelected={(opt) => setSelectedUserIds(opt)}
              selected={selectedUserIds}
              style={{
                width: "200px",
                float: "right",
                marginRight: "10px",
                height: "38px",
                lineHeight: "38px",
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={users?.length || 0}
                />
                {loading ? (
                  <TableBody>
                    <TableRowSkeleton avatar columns={4} />
                  </TableBody>
                ) : (
                  <TableBody>
                    {!quickAnswers || quickAnswers?.length == 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={headCells.length}
                          align="center"
                        >
                          {i18n.t('quickAnswers.table.notFound')}
                        </TableCell>
                      </TableRow>
                    ) : (
                      stableSort(
                        quickAnswers,
                        getComparator(order, orderBy)
                      ).map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            style={{
                              position: "relative",
                              height: "70px",
                            }}
                          >
                            <TableCell align="left">{row.shortcut}</TableCell>
                            <TableCell align="left">
                              {row.message && !row.media && !row.driveUrl ? row.message
                                : !row.message && (row.media || row.driveUrl) ? returnSvg('', row.mediaName, row.driveUrl)
                                  : returnSvg(row.message, row.mediaName, row.driveUrl)
                              }
                            </TableCell>
                            <TableCell align="left">{row.userName}</TableCell>
                            <TableCell style={{ width: 195 }}>
                              <Button
                                title={i18n.t('buttons.edit')}
                                onClick={() => handleEdit(row)}
                                disabled={row.status == false}
                              >
                                <EditOutlinedIcon />
                              </Button>
                              <Button
                                title={i18n.t('buttons.delete')}
                                onClick={() => {
                                  setConfirmModalOpen(true);
                                  setDeletingQuickAnswers(row);
                                }}
                                disabled={row.status == false}
                              >
                                <DeleteOutlineOutlinedIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page - 1}
              labelRowsPerPage={i18n.t("users.table.resultPerPage")}
              labelDisplayedRows={({ from, to, count }) =>
                `${i18n.t("users.table.total")} ${count} / ${i18n.t("users.table.of")} ${from} ${i18n.t("users.table.to")} ${to}`
              }
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>
      </Box>
      <QuickAnswersModal
        open={quickAnswersModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="form-dialog-title"
        quickAnswerId={selectedQuickAnswers && selectedQuickAnswers.id}
      />
      <ConfirmationModal
        title={
          deletingQuickAnswers &&
          `${i18n.t("quickAnswers.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteQuickAnswers(deletingQuickAnswers.id)}
      >
        {i18n.t("quickAnswers.confirmationModal.deleteMessage")}
      </ConfirmationModal>
    </>
  );
};